import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import GrowAGardenAbout from './components/GrowAGardenAbout';
import FruitsCalculator from './components/FruitsCalculator';
import Pets from './components/Pets';
import FruitGiveaway from './components/FruitGiveaway'; // <-- Add this import
import './App.css';

const Nav = () => {
  const [open, setOpen] = useState(false);

  // Close nav when a link is clicked (for mobile)
  const handleLinkClick = () => setOpen(false);

  return (
    <>
      <button
        className="hamburger"
        aria-label="Toggle navigation"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span style={{ transform: open ? 'rotate(45deg) translate(6px, 6px)' : 'none' }} />
        <span style={{ opacity: open ? 0 : 1 }} />
        <span style={{ transform: open ? 'rotate(-45deg) translate(7px, -7px)' : 'none' }} />
      </button>
      <nav className={`nav${open ? ' open' : ''}`}>
        <Link to="/grow-a-garden" onClick={handleLinkClick}>About</Link>
        <Link to="/fruits-calculator" onClick={handleLinkClick}>Fruits Calculator</Link>
        <Link to="/pets" onClick={handleLinkClick}>Pets Guide</Link>
        <Link to="/fruit-giveaway" className="giveaway-nav-btn" onClick={handleLinkClick}>🎁 Giveaway Details</Link>
      </nav>
    </>
  );
};

const Footer = () => (
  <footer className="footer">
    <p>&copy; Nyx Play 2024. All rights reserved.</p>
    <p>
      Follow us on{' '}
      <a href="https://www.youtube.com/@HydroPlayz-r2g" target="_self" rel="noopener noreferrer">Youtube</a>,{' '}
      <a href="https://www.facebook.com/profile.php?id=100064169436154" target="_blank" rel="noopener noreferrer">Facebook</a>, and{' '}
      <a href="https://www.tiktok.com/@hydroplayz3" target="_self" rel="noopener noreferrer">Tiktok</a>.
    </p>
  </footer>
);

function App() {
  return (
    <Router>
      <div className="app">
        <Nav />
        <Routes>
          <Route path="/grow-a-garden" element={<GrowAGardenAbout />} />
          <Route path="/fruits-calculator" element={<FruitsCalculator />} />
          <Route path="/pets" element={<Pets />} />
          <Route path="/fruit-giveaway" element={<FruitGiveaway />} /> {/* <-- Add this line */}
          <Route path="*" element={<GrowAGardenAbout />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;